/**
 * @generated SignedSource<<884885d33acdd2d259149be75bcb57c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type magazinesStyleArticleMoreOnThisContentItemContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "helpersCheckIsMainTopicContent">;
  readonly " $fragmentType": "magazinesStyleArticleMoreOnThisContentItemContent";
};
export type magazinesStyleArticleMoreOnThisContentItemContent$key = {
  readonly " $data"?: magazinesStyleArticleMoreOnThisContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"magazinesStyleArticleMoreOnThisContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "magazinesStyleArticleMoreOnThisContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsMainTopicContent",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Topic",
          "kind": "LinkedField",
          "name": "topics",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "32d72e2faf90369383748f17ef5c1b89";

export default node;
